/**
 * @generated SignedSource<<29b37987ef18c55551301da7f1191b3a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pricingOneDeliveryQuery$variables = Record<PropertyKey, never>;
export type pricingOneDeliveryQuery$data = {
  readonly creditOffers: ReadonlyArray<{
    readonly credits: number;
    readonly description: string | null | undefined;
    readonly features: ReadonlyArray<string>;
    readonly id: string;
    readonly maxPerUser: number | null | undefined;
    readonly priceCents: number;
    readonly purchasable: boolean;
    readonly title: string;
  }>;
  readonly creditPlans: ReadonlyArray<{
    readonly credits: number;
    readonly description: string | null | undefined;
    readonly features: ReadonlyArray<string>;
    readonly id: string;
    readonly priceCents: number;
    readonly title: string;
  }>;
};
export type pricingOneDeliveryQuery = {
  response: pricingOneDeliveryQuery$data;
  variables: pricingOneDeliveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "credits",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceCents",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditOffer",
    "kind": "LinkedField",
    "name": "creditOffers",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPerUser",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "purchasable",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CreditPlan",
    "kind": "LinkedField",
    "name": "creditPlans",
    "plural": true,
    "selections": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "pricingOneDeliveryQuery",
    "selections": (v6/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "pricingOneDeliveryQuery",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "cacheID": "21d830462da304b21dbc9daa07eef9bb",
    "id": null,
    "metadata": {},
    "name": "pricingOneDeliveryQuery",
    "operationKind": "query",
    "text": "query pricingOneDeliveryQuery {\n  creditOffers {\n    id\n    title\n    description\n    features\n    credits\n    priceCents\n    maxPerUser\n    purchasable\n  }\n  creditPlans {\n    id\n    title\n    description\n    features\n    credits\n    priceCents\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e9df9427d74ed2b68ab5cae01bdfb02";

export default node;
